export const formatObject = (array: any[]) => {
  try {
    const newArray = array.map((item) => item.secondField);
    return newArray.join(', ');
  } catch (err) {
    return '';
  }
};
